import { every, filter, map } from 'lodash';

import { getLeases, getSales } from '../selectors/search';
import { getSelectedLeaseIds, getSelectedSaleIds } from '../selectors/select_list';
import { getCurrentTab } from '../selectors/ui';

const defineCompAction = (leaseAction, saleAction) => (
  (...args) => (
    (dispatch, getState) => {
      const currentTab = getCurrentTab(getState());

      switch (currentTab) {
      case 'lease':
        return dispatch(leaseAction(...args));
      case 'sale':
        return dispatch(saleAction(...args));
      }
    }
  )
);

export const CHANGE_SELECTED_LEASES = 'CHANGE_SELECTED_LEASES';
export function changeSelectedLeases(leases) {
  return {
    type: CHANGE_SELECTED_LEASES,
    leases: leases
  };
}

export const CHANGE_SELECTED_SALES = 'CHANGE_SELECTED_SALES';
export function changeSelectedSales(sales) {
  return {
    type: CHANGE_SELECTED_SALES,
    sales: sales
  };
}

export const resetSelectedLeases = () => changeSelectedLeases([]);
export function resetSelectedLeasesOnCurrentPage() {
  return (dispatch, getState) => {
    const state = getState();
    const leaseIds = map(getLeases(state), lease => lease.id);
    const selectedLeaseIds = getSelectedLeaseIds(state) || [];
    dispatch(changeSelectedLeases(selectedLeaseIds.filter(id => !leaseIds.includes(id))));
  };
}

export const resetSelectedSales = () => changeSelectedSales([]);
export function resetSelectedSalesOnCurrentPage() {
  return (dispatch, getState) => {
    const state = getState();
    const saleIds = map(getSales(state), lease => lease.id);
    const selectedSaleIds = getSelectedSaleIds(state) || [];
    dispatch(changeSelectedSales(selectedSaleIds.filter(id => !saleIds.includes(id))));
  };
}

export const resetSelectedComps = defineCompAction(resetSelectedLeases, resetSelectedSales);
export const resetSelectedCompsOnCurrentPage = defineCompAction(
  resetSelectedLeasesOnCurrentPage,
  resetSelectedSalesOnCurrentPage
);

export const toggleSelectLease = lease => (
  (dispatch, getState) => {
    const selectedLeaseIds = getSelectedLeaseIds(getState()) || [];
    let newSelected;

    if (selectedLeaseIds.indexOf(lease.id) > -1) {
      newSelected = filter(selectedLeaseIds, id => id !== lease.id);
    } else {
      newSelected = [...selectedLeaseIds, lease.id];
    }
    dispatch(changeSelectedLeases(newSelected));
  }
);

export const toggleSelectSale = sale => (
  (dispatch, getState) => {
    const selectedSaleIds = getSelectedSaleIds(getState()) || [];
    let newSelected;

    if (selectedSaleIds.indexOf(sale.id) > -1) {
      newSelected = filter(selectedSaleIds, id => id !== sale.id);
    } else {
      newSelected = [...selectedSaleIds, sale.id];
    }
    dispatch(changeSelectedSales(newSelected));
  }
);

export const toggleSelectComp = defineCompAction(toggleSelectLease, toggleSelectSale);

export function toggleSelectAllLeases() {
  return (dispatch, getState) => {
    const leaseIds = getState().search.meta.compIds;
    dispatch(changeSelectedLeases(leaseIds));
  };
}

export const toggleSelectAllLeasesOnCurrentPage = () => (
  (dispatch, getState) => {
    const state = getState();
    const leaseIds = map(getLeases(state), lease => lease.id);
    const selectedLeaseIds = getSelectedLeaseIds(state) || [];
    const allSelected = every(leaseIds, id => selectedLeaseIds.indexOf(id) > -1);

    if (allSelected) {
      dispatch(changeSelectedLeases(selectedLeaseIds.filter(id => !leaseIds.includes(id))));
    } else {
      dispatch(changeSelectedLeases([...new Set([...selectedLeaseIds, ...leaseIds])]));
    }
  }
);

export function toggleSelectAllSales() {
  return (dispatch, getState) => {
    const saleIds = getState().search.meta.compIds;
    dispatch(changeSelectedSales(saleIds));
  };
}

export const toggleSelectAllSalesOnCurrentPage = () => (
  (dispatch, getState) => {
    const state = getState();
    const saleIds = map(getSales(state), sale => sale.id);
    const selectedSaleIds = getSelectedSaleIds(state) || [];
    const allSelected = every(saleIds, id => selectedSaleIds.indexOf(id) > -1);

    if (allSelected) {
      dispatch(changeSelectedSales(selectedSaleIds.filter(id => !saleIds.includes(id))));
    } else {
      dispatch(changeSelectedSales([...new Set([...selectedSaleIds, ...saleIds])]));
    }
  }
);

export const toggleSelectAllComps = defineCompAction(toggleSelectAllLeases, toggleSelectAllSales);
export const toggleSelectAllCompsOnCurrentPage = defineCompAction(
  toggleSelectAllLeasesOnCurrentPage,
  toggleSelectAllSalesOnCurrentPage
);
